import React from 'react';

function StartUp({ onEnter }) {
  return (
    <div className="dashboard">
      <div className="home__center startup__stack">
        <h1 className="startup__title">
          <span className="startup__line startup__line--small">Welcome</span>
          <span className="startup__line startup__line--smaller">to</span>
          <span className="startup__line">Project Valen</span>
        </h1>
        <button
          type="button"
          className="dashboard__button dashboard__button--primary home__button"
          onClick={() => onEnter?.()}
        >
          Enter
        </button>
      </div>
    </div>
  );
}

export default StartUp;
